import React from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Button, Box } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";

export default function RecentActivities({ activities }) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        p: 2.5,
        flexGrow: 1,
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1.5,
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Recent Activities
        </Typography>
        <Button
          size="small"
          endIcon={<ArrowForward />}
          onClick={() => navigate("/dashboard/activities")}
          sx={{ textTransform: "none", fontWeight: 600 }}
        >
          View All
        </Button>
      </Box>

      {activities?.length ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          {activities.slice(0, 5).map((activity) => (
            <Box
              key={activity.id}
              sx={{
                p: 1,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 1,
                overflow: "hidden",
              }}
            >
              <Typography variant="body2" fontWeight={500} noWrap>
                {activity.description}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {new Date(activity.createdAt).toLocaleString()}
              </Typography>
            </Box>
          ))}
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary">
          No recent activity.
        </Typography>
      )}
    </Box>
  );
}
